/**
 * A food label scanned while signed out (screens/ScanLabel.tsx): the token is kept in this tab while the person signs in, so the
 * label's page opens after sign-in even when the sign-in went through another page (Google's). Only the token (a pointer that
 * opens nothing by itself, core foodlabel.ts Q3); 15 minutes at most; this tab only (sessionStorage).
 */
import { isLabelToken } from "@logwave/core";

const KEY = "cc.labelScan";
const TTL_MS = 15 * 60_000;
const store = (): Storage | undefined => { try { return typeof sessionStorage === "undefined" ? undefined : sessionStorage; } catch { return undefined; } };

/** The token in an address (`/f/<token>`, with or without the /app prefix), or null. */
export function labelTokenInPath(pathname: string): string | null {
  const m = pathname.replace(/^\/app(?=\/)/, "").match(/^\/f\/([A-Za-z0-9_-]{22})\/?$/);
  return m && isLabelToken(m[1]) ? m[1]! : null;
}

export function rememberLabel(token: string, now = Date.now()): void {
  try { store()?.setItem(KEY, JSON.stringify({ token, at: now })); } catch { /* private mode: they scan again */ }
}
export function pendingLabel(now = Date.now()): string | null {
  try {
    const v = JSON.parse(store()?.getItem(KEY) ?? "null") as { token?: string; at?: number } | null;
    return v && isLabelToken(v.token) && typeof v.at === "number" && now - v.at < TTL_MS ? v.token : null;
  } catch { return null; }
}
export function forgetLabel(): void {
  try { store()?.removeItem(KEY); } catch { /* nothing kept */ }
}
